import { Shield, ExternalLink } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          {/* Left side - Branding */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <Shield className="w-5 h-5 text-brand-500" />
              <span className="text-sm font-medium text-gray-900">
                Securely Delivered by KEYper Systems
              </span>
            </div>
          </div>

          {/* Right side - Links and Copyright */}
          <div className="flex items-center space-x-6 text-sm text-gray-600">
            <span>© {currentYear} KEYper Systems</span>
            <span className="hidden sm:inline">•</span>
            <a
              href="https://www.keyper.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1 hover:text-brand-600 transition-colors duration-200"
            >
              <span>Privacy Policy</span>
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://www.keyper.com/support"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1 hover:text-brand-600 transition-colors duration-200"
            >
              <span>Support</span>
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>

        {/* Bottom text */}
        <div className="mt-4 pt-4 border-t border-gray-100">
          <p className="text-xs text-gray-500 text-center">
            VaultDrop v{(import.meta as any).env.VITE_APP_VERSION || '1.0.0'} - 
            Enterprise-grade secure file upload system. All uploads are encrypted 
            and stored securely in Azure Blob Storage with comprehensive audit logging.
          </p>
        </div>
      </div>
    </footer>
  );
};